import { MODAL_ACTIONS } from './actionTypes';
import { IModalAction } from './interfaces';

export const toggleOpen = (name: string, payload?: any): IModalAction => ({
  type: MODAL_ACTIONS.ToggleOpen,
  name,
  payload,
});

export const toggleClose = (name: string): IModalAction => ({
  type: MODAL_ACTIONS.ToggleClose,
  name,
});

export const clearData = (name: string): IModalAction => ({
  type: MODAL_ACTIONS.ClearData,
  name,
});
